"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncate = void 0;
var truncate = exports.truncate = "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n";
//# sourceMappingURL=partials.js.map